module.exports = __webpack_public_path__ + "img/logo-red.e33a0141.png";